import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { axiosApi } from "../../utils/axiosApi";

const useSelfAssignToOptions = () => {
    const loginUserData = useSelector((state) => state.loginData.userData)

    const [assignToOptions, setAssignToOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSelfAssignToOptions = async () => {
            setLoading(true);
            const payload = {
                departments: loginUserData?.departmentName,
                empId: "",
                subDepartment: "",
                assignedEmployee: "",
                loginempId: loginUserData?.empId,
            }

            try {
                const res = await axiosApi(`${process.env.REACT_APP_BASE_URL}/emp/getEmployeeByDepartmentWithSelf`,
                    payload
                );

                if (res?.data?.data?.length) {
                    res.data.data.forEach(item => {
                        const userObj = {
                            label: `${item.firstName} ${item.lastName}`,
                            value: item.empId
                        }

                        assignToOptions.push(userObj)
                    })
                    setAssignToOptions([...assignToOptions])
                }
            } catch (err) {
                console.log("Error", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSelfAssignToOptions();
    }, []);

    return { assignToOptions };
};

export default useSelfAssignToOptions;